// Editable event track data. Add new tracks here to expand Aura's genres.
export const tracks = [
  {
    id: "lifestyle-wellness",
    name: "Lifestyle & Wellness",
    description:
      "Nutrition, movement, mental relaxation, stress reset, habit-building, and better daily routines for professionals and teams.",
    status: "Launching first",
    icon: "Sparkles",
    theme: {
      bg: "#E8F0ED",
      text: "#0E4749",
      accent: "#8EAA9C",
      chipBg: "#0E4749",
      chipText: "#FAF9F6",
    },
  },
  {
    id: "technology",
    name: "Technology & AI",
    description:
      "Tech talks, AI workshops, product sessions, developer meetups, founder conversations, and future-of-work events.",
    status: "Coming soon",
    icon: "Cpu",
    theme: {
      bg: "#E5EFFF",
      text: "#003399",
      accent: "#0052FF",
      chipBg: "#0052FF",
      chipText: "#FFFFFF",
    },
  },
  {
    id: "business",
    name: "Business & Leadership",
    description:
      "Professional growth, leadership sessions, startup events, founder meetups, industry panels, and workplace learning experiences.",
    status: "Coming soon",
    icon: "Briefcase",
    theme: {
      bg: "#F5F2EB",
      text: "#0B1D3A",
      accent: "#D4AF37",
      chipBg: "#0B1D3A",
      chipText: "#FFFFFF",
    },
  },
  {
    id: "creativity",
    name: "Creativity & Culture",
    description:
      "Creator gatherings, art-led experiences, cultural conversations, storytelling sessions, music, design, and community showcases.",
    status: "Future track",
    icon: "Palette",
    theme: {
      bg: "#FEF2F0",
      text: "#8B4513",
      accent: "#FF7F50",
      chipBg: "#FF7F50",
      chipText: "#FFFFFF",
    },
  },
  {
    id: "learning",
    name: "Learning & Skill-Building",
    description:
      "Hands-on workshops, practical masterclasses, career development sessions, and guided learning events.",
    status: "Future track",
    icon: "GraduationCap",
    theme: {
      bg: "#EEEAF6",
      text: "#3B2A6A",
      accent: "#B5A6C9",
      chipBg: "#3B2A6A",
      chipText: "#FFFFFF",
    },
  },
  {
    id: "community",
    name: "Community & Networking",
    description:
      "Curated meetups, member circles, interest-based communities, and networking experiences designed to create real connections.",
    status: "Future track",
    icon: "Users",
    theme: {
      bg: "#FFF4E6",
      text: "#994C00",
      accent: "#FF8C00",
      chipBg: "#FF8C00",
      chipText: "#FFFFFF",
    },
  },
];

export const getTrackById = (id) => tracks.find((t) => t.id === id);
